module.exports = __webpack_public_path__ + "static/media/skophat.b2599dea.wav";